import { Helmet } from 'react-helmet';
import ContributionDetail from 'src/features/ContributionDetail';
import MainLayout from 'src/layouts';

const ContributionDetailPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Contribution Detail</title>
      </Helmet>
      <ContributionDetail />
    </MainLayout>
  );
};

export default ContributionDetailPage;
